import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/admin'

// Schema definitions
export const CustomerSchema = z
  .object({
    id: z.string(),
    name: z.string().optional().nullable(),
  })
  .passthrough()

export const OneCommunityResponseCampaignSchema = z
  .object({
    id: z.string(),
    name: z.string().optional().nullable(),
    campaignCategory: z.string().optional().nullable(),
    optionalSettings: z.any().optional().nullable(),
    customerId: z.string().optional().nullable(),
    customer: CustomerSchema.optional().nullable(),
    formIdsEntryCounts: z.number().optional().nullable(),
    alphabaitFormIdEntryCount: z.number().optional().nullable(),
  })
  .passthrough()

// Contract
export const admin = c.router({
  getOneCommunityCampaigns: {
    method: 'GET',
    path: `${prefix}/one-community-campaigns`,
    responses: {
      200: z.array(OneCommunityResponseCampaignSchema),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get OneCommunity campaigns',
  },
  syncOnecommunityCampaign: {
    method: 'POST',
    path: `${prefix}/sync-one-community-campaign/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    body: z.object({}).optional(),
    responses: {
      200: z.object({ campaignId: z.string() }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Sync OneCommunity campaign',
  },
  createForm: {
    method: 'POST',
    path: `${prefix}/create-form/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    body: z.object({}).optional(),
    responses: {
      200: z.object({ success: z.boolean() }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Create OneCommunity form',
  },
  syncMailcampStatus: {
    method: 'POST',
    path: `${prefix}/sync-mailcamp-status/:customerId`,
    pathParams: z.object({
      customerId: z.string(),
    }),
    body: z
      .object({
        limit: z.number().optional(),
      })
      .optional(),
    responses: {
      200: z.object({ updated: z.array(z.string()) }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Sync Mailcamp status',
  },
  validateOneCommunitySync: {
    method: 'GET',
    path: `${prefix}/validate-one-community-sync/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    responses: {
      200: z.object({
        campaignId: z.string(),
        campaignName: z.string().nullable(),
        error: z.string().optional(),
        inSync: z.boolean(),
        totalInOneCommunity: z.number(),
        totalInDatabase: z.number(),
        missingInOneCommunity: z.array(z.string()),
        missingInDatabase: z.array(z.string()),
      }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Validate OneCommunity sync status for a campaign',
  },
  syncMissingOneCommunityEntries: {
    method: 'POST',
    path: `${prefix}/sync-missing-one-community/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    body: z.object({
      endUserIds: z.array(z.string()),
    }),
    responses: {
      200: z.object({
        scheduled: z.number(),
        campaignId: z.string(),
      }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Schedule sync for missing OneCommunity entries',
  },
  backfillEncryption: {
    method: 'POST',
    path: `${prefix}/backfill-encryption`,
    body: z
      .object({
        dryRun: z.boolean().optional(),
      })
      .optional(),
    responses: {
      200: z.object({
        integrations: z.object({
          total: z.number(),
          encrypted: z.number(),
          skipped: z.number(),
          errors: z.number(),
        }),
        dryRun: z.boolean(),
      }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Backfill encrypted credentials for integrations',
  },
  verifyEncryption: {
    method: 'GET',
    path: `${prefix}/verify-encryption`,
    responses: {
      200: z.object({
        integrations: z.object({
          total: z.number(),
          missingCredentialsEncrypted: z.number(),
        }),
        ready: z.boolean(),
      }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Verify encryption backfill completeness',
  },
})
